import { Skeleton } from '@/app/[locale]/[ferry]/Skeleton'

export const SummaryContentDesktopSkeleton = () => {
  return (
    <section
      className="bg-semantic-global-background-white flex h-full w-full flex-col overflow-hidden"
      data-e2e="summary-content-desktop-skeleton"
    >
      {/* Summary Content Skeleton */}
      <div className="pt-semantic-global-md flex h-full flex-col overflow-hidden">
        {/* Generate skeletons for typical steps */}
        {[1, 2, 3, 4, 5, 6, 7].map((stepNumber) => (
          <div
            className="p-semantic-global-lg gap-primitive-24 border-semantic-global-border-light flex flex-col border-b"
            key={stepNumber}
          >
            {/* Step header */}
            <div className="gap-primitive-8 flex w-full flex-row items-center justify-between">
              <div className="typography-heading-sm gap-semantic-global-sm flex items-center">
                <div className="flex size-6 shrink-0 items-center justify-center">
                  <div className="bg-semantic-global-disabled-dark size-6 rounded-full" />
                </div>
                <Skeleton className="h-[20px] w-[120px]" />
              </div>
              <Skeleton className="h-[32px] w-[80px]" />
            </div>

            {/* Step content */}
            <div>
              {stepNumber === 1 ? (
                <div className="w-full space-y-3">
                  <Skeleton className="h-[16px] w-[100px]" />
                  <Skeleton className="h-[16px] w-[150px]" />
                  <Skeleton className="h-[16px] w-[80px]" />
                </div>
              ) : null}

              {stepNumber === 2 ? (
                <div className="gap-semantic-global-lg flex w-full flex-col justify-center">
                  <div className="space-y-3">
                    <Skeleton className="h-[16px] w-[80px]" />
                    <Skeleton className="h-[20px] w-full" />
                    <Skeleton className="h-[16px] w-[120px]" />
                  </div>
                  <div className="space-y-3">
                    <Skeleton className="h-[16px] w-[80px]" />
                    <Skeleton className="h-[20px] w-full" />
                    <Skeleton className="h-[16px] w-[120px]" />
                  </div>
                </div>
              ) : null}

              {stepNumber === 3 ? (
                <div className="flex min-h-[20px] w-full flex-col justify-center space-y-2">
                  <div className="flex items-center justify-between">
                    <Skeleton className="h-[16px] w-[100px]" />
                    <Skeleton className="h-[16px] w-[60px]" />
                  </div>
                  <div className="flex items-center justify-between">
                    <Skeleton className="h-[16px] w-[120px]" />
                    <Skeleton className="h-[16px] w-[60px]" />
                  </div>
                </div>
              ) : null}

              {stepNumber === 4 ? (
                <div className="gap-semantic-global-xs flex min-h-[20px] w-full flex-col justify-center">
                  <Skeleton className="h-[16px] w-[80px]" />
                  <div className="space-y-2">
                    <div className="flex items-center justify-between">
                      <Skeleton className="h-[16px] w-[140px]" />
                      <Skeleton className="h-[16px] w-[60px]" />
                    </div>
                    <div className="flex items-center justify-between">
                      <Skeleton className="h-[16px] w-[100px]" />
                      <Skeleton className="h-[16px] w-[60px]" />
                    </div>
                  </div>
                </div>
              ) : null}

              {stepNumber === 5 ? (
                <div className="gap-primitive-16 flex min-h-[20px] w-full flex-col justify-center">
                  <div className="space-y-2">
                    <Skeleton className="h-[16px] w-[80px]" />
                    <Skeleton className="h-[16px] w-[150px]" />
                  </div>
                  <div className="space-y-2">
                    <Skeleton className="h-[16px] w-[80px]" />
                    <Skeleton className="h-[16px] w-[150px]" />
                  </div>
                </div>
              ) : null}
              {stepNumber === 6 ? (
                <div className="gap-primitive-16 flex min-h-[20px] w-full flex-col justify-center">
                  <div className="space-y-3">
                    <Skeleton className="h-[16px] w-[120px]" />
                    <div className="space-y-2">
                      <Skeleton className="h-[16px] w-[100px]" />
                      <Skeleton className="h-[16px] w-[180px]" />
                      <Skeleton className="h-[16px] w-[140px]" />
                    </div>
                  </div>
                  <div className="space-y-3">
                    <Skeleton className="h-[16px] w-[100px]" />
                    <div className="space-y-2">
                      <Skeleton className="h-[16px] w-[160px]" />
                      <Skeleton className="h-[16px] w-[120px]" />
                    </div>
                  </div>
                </div>
              ) : null}
              {stepNumber === 7 ? (
                <div className="w-full">
                  <Skeleton className="h-[16px] w-[300px]" />
                </div>
              ) : null}
            </div>
          </div>
        ))}
      </div>

      {/* Bottom section skeleton */}
      <section className="p-semantic-global-md border-semantic-global-border-light w-full border-t bg-white">
        <div className="gap-semantic-global-md flex flex-col">
          <div className="flex flex-row items-center justify-between">
            <Skeleton className="h-[20px] w-[100px]" />
            <Skeleton className="h-[24px] w-[80px]" />
          </div>
          <Skeleton className="h-[48px] w-full" square />
        </div>
      </section>
    </section>
  )
}
